<section class="flex flex-col justify-center mx-2">
  <h1 class="px-2 mx-auto text-2xl">Changelog</h1>

  <form
    class="flex flex-wrap items-end gap-2 p-2 my-2 bg-gray-800 border border-gray-700 border-solid"
    (ngSubmit)="load()"
  >
    <label class="flex flex-col text-sm">
      Typ
      <select
        class="px-2 py-1 text-black bg-gray-200 border border-gray-500 border-solid"
        name="selectedType"
        [(ngModel)]="selectedType"
      >
        <option value="">Alle</option>
        <option *ngFor="let type of types" [value]="type.value">
          {{ type.label }}
        </option>
      </select>
    </label>
    <label class="flex flex-col text-sm">
      Spieler-ID
      <input
        class="px-2 py-1 text-black bg-gray-200 border border-gray-500 border-solid"
        type="number"
        name="playerId"
        [(ngModel)]="playerId"
      />
    </label>
    <label class="flex flex-col text-sm">
      Von
      <input
        class="px-2 py-1 text-black bg-gray-200 border border-gray-500 border-solid"
        type="datetime-local"
        name="from"
        [(ngModel)]="from"
      />
    </label>
    <label class="flex flex-col text-sm">
      Bis
      <input
        class="px-2 py-1 text-black bg-gray-200 border border-gray-500 border-solid"
        type="datetime-local"
        name="to"
        [(ngModel)]="to"
      />
    </label>
    <button
      class="px-3 py-1 text-white border border-white border-solid hover:text-orange-300 hover:border-orange-300"
      type="submit"
    >
      Filtern
    </button>
    <button
      class="px-3 py-1 text-white border border-white border-solid hover:text-orange-300 hover:border-orange-300"
      type="button"
      (click)="reset()"
    >
      Zurücksetzen
    </button>
  </form>

  <p *ngIf="loading" class="px-2">Loading...</p>
  <p *ngIf="error" class="px-2 text-red-300">{{ error }}</p>

  <table
    *ngIf="!loading"
    class="text-sm bg-gray-900 border border-gray-800 border-solid"
  >
    <thead>
      <tr>
        <th class="px-2 text-left bg-gray-700 border border-gray-800 border-solid">
          Zeit
        </th>
        <th class="px-2 text-left bg-gray-700 border border-gray-800 border-solid">
          Typ
        </th>
        <th class="px-2 text-left bg-gray-700 border border-gray-800 border-solid">
          Änderung
        </th>
        <th class="px-2 text-left bg-gray-700 border border-gray-800 border-solid">
          Werte
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="entries.length === 0">
        <td
          class="px-2 text-center border border-gray-800 border-solid"
          colspan="4"
        >
          Keine Einträge
        </td>
      </tr>
      <tr *ngFor="let entry of entries">
        <td class="px-2 whitespace-nowrap border border-gray-800 border-solid">
          {{ entry.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </td>
        <td class="px-2 whitespace-nowrap border border-gray-800 border-solid">
          {{ typeLabel(entry.type) }}
        </td>
        <td class="px-2 border border-gray-800 border-solid">
          <span [innerHTML]="describe(entry) | safeHtml"></span>
        </td>
        <td class="px-2 border border-gray-800 border-solid">
          {{ changedValues(entry) }}
        </td>
      </tr>
    </tbody>
  </table>
</section>
